import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    shortname: String,
    pageUrl: String,
    pageId: String,
    pageTitle: String
  }

  connect() {
    // Only load Disqus if shortname is configured
    if (!this.shortnameValue || this.shortnameValue === "your-disqus-shortname") {
      return
    }

    // Capture values for Disqus config
    const pageUrl = this.pageUrlValue
    const pageId = this.pageIdValue
    const pageTitle = this.pageTitleValue

    // Configure Disqus
    window.disqus_config = function () {
      this.page.url = pageUrl
      this.page.identifier = pageId
      this.page.title = pageTitle
    }

    // Load Disqus embed script
    const d = document
    const s = d.createElement("script")
    s.src = `https://${this.shortnameValue}.disqus.com/embed.js`
    s.setAttribute("data-timestamp", +new Date())
      ; (d.head || d.body).appendChild(s)

    // Load Disqus count script
    const countScript = d.createElement("script")
    countScript.id = "dsq-count-scr"
    countScript.src = `https://${this.shortnameValue}.disqus.com/count.js`
    countScript.async = true
      ; (d.head || d.body).appendChild(countScript)
  }
}

